import type { SupportedGame } from '@/config/supportedGames';
import { Game } from '@/constants/game.const';

export function getGameLogoFromGame(game: SupportedGame): string {
  switch (game) {
    case Game.DOTA:
      return '/logos/dota2.svg';
    case Game.CS2:
      return '/logos/cs2.svg';
    default:
      game satisfies never;
      throw new Error(`Unsupported game: ${game}`);
  }
}
